module.exports = __webpack_public_path__ + "static/img/lxwm.3773881c.png";